module.exports = __webpack_public_path__ + "static/media/DZ.322f59c2.png";